import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface OrderReportInterface {
  serials: string;
  note: string;
}

@Component({
  selector: 'app-note-editor',
  templateUrl: './note-editor.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule
  ],
})
export class NoteEditorComponent {

  noteContent: string = '';

  constructor(
    private dialogRef: MatDialogRef<NoteEditorComponent>,
     @Inject(MAT_DIALOG_DATA) public data: OrderReportInterface)
   {

  }
  ngOnInit() {
    if (this.data) {
      this.noteContent = this.data.note;
    }
  }

  onSave() {
    this.dialogRef.close(this.noteContent);
  }

  onCancel() {
    this.dialogRef.close();
  }
}